import {
  Question as QuestionType,
  DependentQuestion,
} from '../../types';

export const handleDependencyCheck =
  (parent: QuestionType, dependency: DependentQuestion): boolean => {
  switch (dependency.operator) {
    case '=':
      return parent.value === dependency.value;
    case '!=':
      return parent.value !== dependency.value;
    case 'includes':
      return parent.value?.includes(dependency.value) || false;
    case 'not includes':
      return !parent.value?.includes(dependency.value);;
    default:
      console.warn(`operator ${dependency.operator} not supported`)
      return false;
  }
}

export const checkRender =
  (questions: QuestionType[], question: QuestionType): boolean => {
  if (question.dependencies &&
    question.dependencies?.length === 0) {
    question.render = true;
    return true;
  } else {
    let canRender = false;
      question.dependencies &&
      question.dependencies.every((dep: DependentQuestion) => {
        const parent_question = questions.filter(
          (q) => q.id === dep.parent_question_id
        )[0];
        canRender = handleDependencyCheck(parent_question, dep);
        if (!canRender) {return false};
      });
      question.render = canRender;
      return canRender;
    }
  };

  export const getNextQuestion = 
    (curIdx: number, questions: QuestionType[], reverse: boolean): number =>
  {
    if (questions.length === curIdx) {
      return curIdx;
    } else {
      const canRender = checkRender(questions, questions[curIdx]);
      const increment = reverse ? curIdx - 1 : curIdx + 1;
      if (!canRender) {
        return getNextQuestion(increment, questions, reverse);
      } else {
        return curIdx;
      }
    }
  }